import { useStaticQuery, graphql } from 'gatsby';

const useSiteSettings = () => {
  let menu = [];

  const { allPaperformHelpSiteSettings } = useStaticQuery(
    graphql`
      query SiteSettingsQuery {
        allPaperformHelpSiteSettings {
          edges {
            node {
              register_button_text_paperform
              register_button_text_papersign
              pricing_papersign_link {
                show
                url
              }
            }
          }
        }
      }
    `,
  );

  const data = allPaperformHelpSiteSettings?.edges[0]?.node;

  return data || menu;
};

export default useSiteSettings;
